import { useMemo } from 'react'

import {
  E2E_ORDER_DETAILS_TAGS,
  E2E_ORDER_DETAILS_TAGS_ADD,
  E2E_ORDER_DETAILS_TAGS_REMOVE,
} from 'Constants/e2e'

import { EntityTagsInner } from './EntityTagsInner'
import { EntityTagsProvider } from './EntityTagsProvider'
import { orderTaggingAdapter } from './orderTaggingAdapter'
import type { OrderTagsRowProps } from './OrderTagsRow.types'
import type { Tag } from './tagging.types'

export const OrderTagsRow = (props: OrderTagsRowProps) => {
  const { caseItem, readOnly = false, refetch } = props
  const caseItemId = caseItem.id

  const caseItemTags = useMemo<Tag[]>(
    () =>
      (caseItem.tags ?? []).map(tag => ({
        color: tag.color,
        id: tag.id,
        name: tag.name,
      })),
    [caseItem.tags],
  )

  return (
    <EntityTagsProvider
      adapter={orderTaggingAdapter}
      entityId={caseItemId}
      entityTags={caseItemTags}
      refetch={refetch}
    >
      <EntityTagsInner
        addDataE2e={E2E_ORDER_DETAILS_TAGS_ADD}
        className="OrderTagsRow"
        detailsDataE2e={E2E_ORDER_DETAILS_TAGS}
        entityId={caseItemId}
        readOnly={readOnly}
        removeDataE2e={E2E_ORDER_DETAILS_TAGS_REMOVE}
        tags={caseItemTags}
      />
    </EntityTagsProvider>
  )
}
